import {
  FETCH_LOCATION_DETAIL_REQUEST,
  FETCH_LOCATION_POPULAR_AREAS_REQUEST,
  FETCH_LOCATION_RECOMMENDED_SPACES_REQUEST,
  FETCH_LOCATION_COIN_LOCKERS_REQUEST,
  FETCH_LOCATION_STATIONS_REQUEST,
  FETCH_LOCATION_FACILITIES_REQUEST,
  FETCH_LOCATION_OLD_COIN_LOCKERS_REQUEST,
} from './types'
import { takeLatest, take, fork } from 'redux-saga/effects'
import {
  fetchLocationDetailSaga,
  fetchLocationPopularAreasSaga,
  fetchLocationRecommendedSpacesSaga,
  fetchLocationCoinLockersSaga,
  fetchLocationStationsSaga,
  fetchLocationFacilitiesSaga,
  fetchLocationOldCoinLockers,
} from './sagas'

// 都道府県ごとの施設データキャッシュ
const stationsCache = new Map()
const facilitiesCache = new Map()

export function* watchLocationDetailSaga() {
  yield takeLatest(FETCH_LOCATION_DETAIL_REQUEST, fetchLocationDetailSaga)
}

export function* watchLocationPopularAreasSaga() {
  yield takeLatest(FETCH_LOCATION_POPULAR_AREAS_REQUEST, fetchLocationPopularAreasSaga)
}

export function* watchLocationRecommendedSpacesSaga() {
  yield takeLatest(FETCH_LOCATION_RECOMMENDED_SPACES_REQUEST, fetchLocationRecommendedSpacesSaga)
}

export function* watchLocationCoinLockersSaga() {
  yield takeLatest(FETCH_LOCATION_COIN_LOCKERS_REQUEST, fetchLocationCoinLockersSaga)
}

// 駅
export function* watchLocationStationsSaga() {
  while (true) {
    const action = yield take(FETCH_LOCATION_STATIONS_REQUEST)
    const prefectureId = action.payload.prefectureId

    // キャッシュされていない場合のみ実行
    if (!stationsCache.has(prefectureId)) {
      stationsCache.set(prefectureId, true)
      yield fork(fetchLocationStationsSaga, action)
    }
  }
}

// 施設
export function* watchLocationFacilitiesSaga() {
  while (true) {
    const action = yield take(FETCH_LOCATION_FACILITIES_REQUEST)
    const prefectureId = action.payload.prefectureId

    // キャッシュされていない場合のみ実行
    if (!facilitiesCache.has(prefectureId)) {
      facilitiesCache.set(prefectureId, true)
      yield fork(fetchLocationFacilitiesSaga, action)
    }
  }
}

// 旧コインロッカー
export function* watchLocationOldCoinLockersSaga() {
  yield takeLatest(FETCH_LOCATION_OLD_COIN_LOCKERS_REQUEST, fetchLocationOldCoinLockers)
}
